var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-img',{staticClass:"mb-8 mx-auto",attrs:{"alt":"Vuetify + Tidelift","contain":"","height":"210","src":"https://cdn.vuetifyjs.com/images/affiliates/vuetify-tidelift.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }